import React from 'react';
import PropTypes from 'prop-types';

class InputToggleCheckbox extends React.Component {
  render () {
    const { label, className, style, uniqueId, isUnTogglable, checkboxClassName,
      ...others
    } = this.props;

    const isCheckBoxDisabled = isUnTogglable ? 'tgl-disabled' : '';
    return (
      <label className={className} style={style}>
        <input type="checkbox" id={uniqueId} className={`tgl tgl-light push-half--right ${checkboxClassName}`} {...others} />
        <label className={`tgl-btn ${isCheckBoxDisabled}`} htmlFor={uniqueId}></label>
        {label}
      </label>
    );
  }
}

InputToggleCheckbox.propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
  uniqueId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
};

InputToggleCheckbox.defaultProps = {
  checkboxClassName: '',
};

export default InputToggleCheckbox;



// WEBPACK FOOTER //
// ./src/common/views/form/InputToggleCheckbox.js